
"use client";

import { useEffect, useState } from "react";
import {
  X,
  Upload,
  Plus,
  Trash,
  Star,
  Award,
  FlameIcon as Fire,
} from "lucide-react";
import { useCloud } from "../hooks/useCloud";
import toast from "react-hot-toast";
import store from "../store";

export function AddMenuItemForm({
  menuItem,
  categories = [],
  selectedCategory,
  onClose,
  onSubmit,
}) {
  const { uploadMenuItemImage, deleteMenuItemImage } = useCloud();
  const DISABLED_FEATURES = [""];
  const [showVariationModal, setShowVariationModal] = useState(false);
  const [showAddOnModal, setShowAddOnModal] = useState(false);
  const [showPriceRuleModal, setShowPriceRuleModal] = useState(false);
  // Update the currentVariation state to include priceRules instead of customerPricing
  const [currentVariation, setCurrentVariation] = useState({
    name: "",
    price: "",
    priceRules: [],
  });
  const [currentAddOn, setCurrentAddOn] = useState({ name: "", price: "" });
  const [currentAddOnIndex, setCurrentAddOnIndex] = useState(null);
  const [currentPriceRule, setCurrentPriceRule] = useState({
    room: "",
    table: "",
    time: "",
    timeStart: "",
    timeEnd: "",
    price: "",
  });
  const [deletedVariations, setDeletedVariations] = useState([]);
  const [deletedAddOns, setDeletedAddOns] = useState([]);
  const [currentVariationIndex, setCurrentVariationIndex] = useState(null);
  const [currentPriceRuleIndex, setCurrentPriceRuleIndex] = useState(null);
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  // Replace currentCustomerPrice with currentVariationPriceRule
  const [currentVariationPriceRule, setCurrentVariationPriceRule] = useState({
    room: "",
    table: "",
    time: "",
    timeStart: "",
    timeEnd: "",
    price: "",
  });

  const initialFormData = {
    name: "",
    rank: 0,
    amount: "",
    price: "",
    discountAmount: 0,
    halfPrice: "",
    acPrice: "",
    description: "",
    image: "",
    imgUrl: "",
    itmNo: "",
    veg: false,
    nonveg: false,
    specify: false,
    chefspe: false,
    bestSellar: false,
    reating: "0",
    rating: "0",
    gst: "0",
    pkgCharge: "0",
    variant: [],
    addOns: [],
    subCategoryName: "Na",
    categoryId: selectedCategory?.categoryId || "",
    category: selectedCategory?.categoryName || "",
    priceRules: [],
    status: true,
    varient: {
      status: true,
      items: [],
    },
    isAddOns: {
      status: true,
      items: [],
    },
  };

  const [formData, setFormData] = useState(initialFormData);

  const [imagePreview, setImagePreview] = useState(null);
  const [variations, setVariations] = useState([]);
  const [addOns, setAddOns] = useState([]);
  const [priceRules, setPriceRules] = useState([]);
  const [discountError, setDiscountError] = useState(false);

  useEffect(() => {
    if (menuItem) {
      // Map the base properties to form data
      setFormData({
        id: menuItem.id || "",
        name: menuItem.itemName || "",
        rank: menuItem.rank || 0,
        amount: menuItem.price?.toString() || "",
        price: menuItem.price?.toString() || "",
        halfPrice: "",
        acPrice: "",
        description: menuItem.description || "",
        image:
          menuItem.images && menuItem.images.length > 0
            ? menuItem.images[0]
            : "",
        imgUrl: "",
        status: menuItem.status === "active",
        itmNo: menuItem.restaurantCode || "",
        veg: menuItem.itemType?.veg || false,
        nonveg: menuItem.itemType?.nonVeg || false,
        specify: menuItem.itemType?.spicy || false,
        chefspe: menuItem.itemType?.chefSpecial || false,
        bestSellar: menuItem.itemType?.bestSeller || false,
        reating: menuItem.rating?.toString() || "0",
        rating: menuItem.rating?.toString() || "0",
        gst: "0",
        pkgCharge: "0",
        variant: [],
        addOns: [],
        subCategoryName: "Na",
        categoryId: menuItem.categoryId || "",
        category: menuItem.categoryDetails?.categoryName || "",
        priceRules: menuItem.priceRule || [],
        categoryDetails: menuItem.categoryDetails || null,
        varient: {
          status: true,
          items: [],
        },
        isAddOns: {
          status: true,
          items: [],
        },
        discountAmount: menuItem.discountAmount || 0,
      });

      // Handle image preview
      if (menuItem.images && menuItem.images.length > 0 && menuItem.images[0]) {
        setImagePreview(menuItem.images[0]);
      }

      // Handle variations
      if (menuItem.variation && menuItem.variation.length > 0) {
        const variations = menuItem.variation.map((variant) => ({
          id: variant.id || "",
          name: variant.name || "",
          amount: variant.price?.toString() || "0",
          price: variant.price?.toString() || "0",
          image: variant.image || "",
          status: variant.status || "active",
          priceRules: variant.priceRule || [],
        }));
        setVariations(variations);
      } else {
        setVariations([]);
      }

      // Handle add-ons
      if (menuItem.addOn && menuItem.addOn.length > 0) {
        const addOns = menuItem.addOn.map((addon) => ({
          id: addon.id || "",
          name: addon.name || "",
          amount: addon.price?.toString() || "0",
          price: addon.price?.toString() || "0",
          status: addon.status || "active",
        }));
        setAddOns(addOns);
      } else {
        setAddOns([]);
      }

      // Handle price rules
      if (menuItem.priceRule && menuItem.priceRule.length > 0) {
        try {
          const parsedRules = Array.isArray(menuItem.priceRule)
            ? menuItem.priceRule.map(parseRuleString)
            : [];
          setPriceRules(parsedRules);
        } catch (error) {
          console.error("Error parsing price rules:", error);
          setPriceRules([]);
        }
      } else {
        setPriceRules([]);
      }

      // Set rating
      setRating(Number.parseFloat(menuItem.rating?.toString() || "0"));
    }
  }, [menuItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let amount = formData.amount;
    let reating = formData.reating;
    if (name == "price") {
      amount = value;
    }
    if (name == "rating") {
      reating = value;
    }
    if (name === "discountAmount") {
      const isInvalid = value !== "" && Number(value) > Number(formData.price);
      setDiscountError(isInvalid);
      if (isInvalid) {
        toast.error("Discount cannot be greater than price");
        return;
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      amount,
      reating,
    }));

    // Update category name if categoryId changes
    if (name === "categoryId" && categories) {
      const selectedCategory = categories.find(
        (cat) => cat.categoryId === value
      );
      if (selectedCategory) {
        setFormData((prev) => ({
          ...prev,
          categoryId: selectedCategory.categoryId,
          category: selectedCategory.categoryName,
        }));
      }
    }
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Show loading state
      const loadingToast = toast.loading("Uploading image...");

      const response = await uploadMenuItemImage(
        formData.categoryId,
        formData.id,
        file
      );

      if (response.success) {
        setImagePreview(response.data.imageUrl);
        setFormData((prev) => ({
          ...prev,
          image: [response.data.imageUrl],
        }));
        toast.success("Image uploaded successfully", { id: loadingToast });
      } else {
        toast.error(response.message || "Failed to upload image", {
          id: loadingToast,
        });
      }
    } catch (error) {
      toast.error("Error uploading image");
      console.error("Image upload error:", error);
    }
  };

  const handleImageDelete = async (e) => {
    e.stopPropagation();

    setImagePreview(null);
    setFormData((prev) => ({
      ...prev,
      images: [],
    }));

    toast.success("Image removed successfully");
  };

  // Star rating handler
  const handleRatingChange = (newRating) => {
    setRating(newRating);
    setFormData((prev) => ({
      ...prev,
      rating: newRating.toString(),
      reating: newRating.toString(),
    }));
  };

  // Variation handling
  // Update the openVariationModal function to handle priceRules
  const openVariationModal = (variation = null, index = null) => {
    if (variation) {
      setCurrentVariation({
        ...variation,
      });
      setCurrentVariationIndex(index);
    } else {
      setCurrentVariation({ name: "", price: "", priceRules: [] });
      setCurrentVariationIndex(null);
    }
    setShowVariationModal(true);
  };

  const saveVariation = () => {
    if (currentVariationIndex !== null) {
      // Edit existing
      const updatedVariations = [...variations];
      updatedVariations[currentVariationIndex] = {
        ...currentVariation,
        priceRules: currentVariation.priceRules,
      };
      setVariations(updatedVariations);
    } else {
      // Add new
      setVariations([
        ...variations,
        { ...currentVariation, priceRules: currentVariation.priceRules },
      ]);
    }
    setShowVariationModal(false);
  };

  const removeVariation = (index) => {
    const deletedVariation = variations[index];
    const updatedVariations = variations.filter((_, i) => i !== index);
    setVariations(updatedVariations);
    setDeletedVariations((prev) => {
      prev.push(deletedVariation);
      return prev;
    });
  };

  // Add-on handling
  const openAddOnModal = (addon = null, index = null) => {
    if (addon) {
      setCurrentAddOn(addon);
      setCurrentAddOnIndex(index);
    } else {
      setCurrentAddOn({ name: "", price: "" });
      setCurrentAddOnIndex(null);
    }
    setShowAddOnModal(true);
  };

  const saveAddOn = () => {
    if (currentAddOnIndex !== null) {
      // Edit existing
      const updatedAddOns = [...addOns];
      updatedAddOns[currentAddOnIndex] = currentAddOn;
      setAddOns(updatedAddOns);
    } else {
      // Add new
      setAddOns([...addOns, currentAddOn]);
    }
    setShowAddOnModal(false);
  };

  const removeAddOn = (index) => {
    const deletedAddon = addOns[index];
    const updatedAddOns = addOns.filter((_, i) => i !== index);
    setAddOns(updatedAddOns);
    setDeletedAddOns((prev) => {
      prev.push(deletedAddon);
      return prev;
    });
  };

  // Price rule handling
  const openPriceRuleModal = (rule = null, index = null) => {
    if (rule) {
      setCurrentPriceRule(rule);
      setCurrentPriceRuleIndex(index);
    } else {
      setCurrentPriceRule({ room: "", table: "", time: "", price: "" });
      setCurrentPriceRuleIndex(null);
    }
    setShowPriceRuleModal(true);
  };

  const stringifyRule = ({ price, room, table, time, timeEnd, timeStart }) => {
    const _room = room == "All" ? "*" : room;
    const _table = table == "All" ? "*" : table;
    const _time = time == "Whole Day" ? "*" : time;
    return `${_room},${_table},${_time},${price}`;
  };

  const parseRuleString = (rule) => {
    // If rule is a string (old format), parse it
    if (typeof rule === "string") {
      const [room, table, time, price] = rule.split(",");

      return {
        id: "", // No ID in the old format
        room: room === "*" ? "All" : room,
        table: table === "*" ? "All" : table,
        time: time === "*" ? "Whole Day" : time,
        timeStart: time !== "*" ? time.split("-")[0] : "",
        timeEnd: time !== "*" ? time.split("-")[1] : "",
        price: Number.parseFloat(price),
        status: "active", // Default status
      };
    }
    // If rule is an object (new format), map it to our expected structure
    else if (typeof rule === "object" && rule !== null) {
      return {
        id: rule.id || "",
        room: rule.room === "*" ? "All" : rule.room,
        table: rule.table === "*" ? "All" : rule.table,
        time:
          rule.startTime && rule.endTime
            ? `${rule.startTime}-${rule.endTime}`
            : "Whole Day",
        timeStart: rule.startTime || "",
        timeEnd: rule.endTime || "",
        price: Number.parseFloat(rule.price),
        status: rule.status || "active",
      };
    }

    // Return default empty rule if input is invalid
    return {
      id: "",
      room: "",
      table: "",
      time: "",
      timeStart: "",
      timeEnd: "",
      price: 0,
      status: "active",
    };
  };

  const savePriceRule = () => {
    const finalRule = { ...currentPriceRule };

    // Format time range if custom time is selected
    if (
      currentPriceRule.time === "Custom" &&
      currentPriceRule.timeStart &&
      currentPriceRule.timeEnd
    ) {
      finalRule.time = `${currentPriceRule.timeStart}-${currentPriceRule.timeEnd}`;
    }

    if (currentPriceRuleIndex !== null) {
      // Edit existing rule
      const updatedRules = [...priceRules];
      updatedRules[currentPriceRuleIndex] = finalRule;
      setPriceRules(updatedRules);
    } else {
      // Add new rule
      setPriceRules([...priceRules, finalRule]);
    }

    // Close modal
    setShowPriceRuleModal(false);

    // Reset current rule
    setCurrentPriceRule({
      room: "",
      table: "",
      time: "",
      timeStart: "",
      timeEnd: "",
      price: "",
    });
  };

  const removePriceRule = (index) => {
    // Remove the rule at the specified index
    const updatedRules = priceRules.filter((_, i) => i !== index);
    setPriceRules(updatedRules);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const menuItem = {
      id: formData.id || "",
      categoryId: formData.categoryId,
      category: formData.category.trim(),
      itemName: formData.name.trim(),
      description: formData.description.trim(),
      images: formData.image,
      price: Number.parseInt(formData.price) || 0,
      rating: Number.parseFloat(formData.rating || 0),
      rank: Number.parseInt(formData.rank) || 0,
      itemType: {
        veg: formData.veg,
        nonVeg: formData.nonveg,
        spicy: formData.specify,
        chefSpecial: formData.chefspe,
        bestSeller: formData.bestSellar,
        id: formData.itemType?.id || "6024bf6d015e0099c5e1130c",
      },
      outOfStock: false,
      restaurantCode: formData.itmNo || "NA",
      variation: variations.map((variant) => ({
        id: variant.id || "",
        name: variant.name.trim(),
        price: Number.parseInt(variant.amount) || 0,
        image: variant.image || "",
        priceRule: variant.priceRules || [],
        status: "active",
      })),
      addOn: addOns.map((addon) => ({
        id: addon.id || undefined,
        name: addon.name.trim(),
        price: Number.parseInt(addon.amount) || 0,
        status: "active",
      })),
      priceRule: priceRules.length > 0 ? priceRules : [],
      itemSuggestion: [],
      status: formData.status ? "active" : "inactive",
      categoryDetails: formData.categoryDetails || null,
      discountAmount: Number(formData.discountAmount) || 0,
    };
    onSubmit(menuItem, () => {
      setFormData(initialFormData);
      setImagePreview(null);
      setVariations([]);
      setAddOns([]);
      setPriceRules([]);
      setRating(0);
      setHoverRating(0);
    });
  };

  // Replace addCustomerPricing with addVariationPriceRule
  const addVariationPriceRule = () => {
    const finalRule = { ...currentVariationPriceRule };

    // Format time range if custom time is selected
    if (
      currentVariationPriceRule.time === "Custom" &&
      currentVariationPriceRule.timeStart &&
      currentVariationPriceRule.timeEnd
    ) {
      finalRule.time = `${currentVariationPriceRule.timeStart}-${currentVariationPriceRule.timeEnd}`;
    }

    if (
      finalRule.room &&
      finalRule.table &&
      finalRule.time &&
      finalRule.price
    ) {
      try {
        const rule = finalRule;
        setCurrentVariation({
          ...currentVariation,
          priceRules: [...(currentVariation.priceRules || []), finalRule],
        });
        setCurrentVariationPriceRule({
          room: "",
          table: "",
          time: "",
          timeStart: "",
          timeEnd: "",
          price: "",
        });
      } catch (e) {
        toast.error("Something went wrong please try again!");
      }
    }
  };

  // Replace removeCustomerPricing with removeVariationPriceRule
  const removeVariationPriceRule = async (index) => {
    try {
      const updatedRules = [...currentVariation.priceRules];
      updatedRules.splice(index, 1);
      setCurrentVariation({
        ...currentVariation,
        priceRules: updatedRules,
      });
    } catch (e) {
      toast.error("Something went wrong please try again!");
    }
  };

  const closeVariationModal = () => {
    setShowVariationModal(false);
    setCurrentVariationPriceRule({
      room: "",
      table: "",
      time: "",
      timeStart: "",
      timeEnd: "",
      price: "",
    });
  };
  return (
    <div
      data-testid="add-menu-item-form-modal"
      className="flex fixed inset-0 z-50 flex-col h-screen bg-white"
      style={{ zIndex: 502 }}
    >
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <h2 className="text-base font-medium text-gray-800">
          {menuItem ? "Edit Menu Item" : "Add New Menu Item"}
        </h2>
        <button
          data-testid="close-menu-item-form-button"
          onClick={onClose}
          className="p-1 text-gray-500 rounded-full transition-all duration-200 hover:text-gray-700 hover:bg-gray-100"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Main Content */}
      <div className="overflow-y-auto flex-1 p-6">
        <form
          id="menu-item-form"
          onSubmit={handleSubmit}
          className="mx-auto space-y-8 max-w-5xl"
        >
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {/* Left Column */}
            <div className="space-y-6">
              <div>
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-sm font-medium text-gray-700">
                    Menu Item Image
                  </h3>
                  {!formData.id && (
                    <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-yellow-800 bg-yellow-50 rounded border border-yellow-200">
                      Save item first to add image
                    </span>
                  )}
                </div>
                <div
                  className={`border-2 border-dashed rounded-xl p-6 flex flex-col items-center justify-center ${formData.id
                    ? "cursor-pointer hover:border-blue-400 border-gray-300 bg-gray-50"
                    : "cursor-not-allowed border-gray-200 bg-gray-100"
                    } transition-all duration-200`}
                  onClick={() => {
                    if (formData.id) {
                      document.getElementById("image-upload").click();
                    }
                  }}
                  title={
                    !formData.id
                      ? "Save menu item first to enable image upload"
                      : ""
                  }
                >
                  {imagePreview ? (
                    <div className="relative w-full">
                      <img
                        src={
                          imagePreview ||
                          "/placeholder.svg?height=160&width=200" ||
                          "/placeholder.svg"
                        }
                        alt="Menu item preview"
                        className="object-contain w-full h-40"
                        crossOrigin="anonymous"
                        loading="lazy"
                      />
                      <button
                        type="button"
                        className="absolute -top-2 -right-2 p-1 text-gray-600 bg-white rounded-full shadow-sm transition-all duration-200 hover:bg-gray-100"
                        onClick={async (e) => handleImageDelete(e)}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ) : (
                    <>
                      <Upload
                        className={`w-6 h-6 mb-2 ${formData.id ? "text-gray-400" : "text-gray-300"
                          }`}
                      />
                      <p
                        className={`text-sm ${formData.id ? "text-gray-500" : "text-gray-400"
                          }`}
                      >
                        {formData.id
                          ? "Click to upload menu item image"
                          : "Save menu item first to upload image"}
                      </p>
                      <p
                        className={`mt-1 text-xs ${formData.id ? "text-gray-400" : "text-gray-300"
                          }`}
                      >
                        PNG, JPG, GIF up to 5MB
                      </p>
                    </>
                  )}
                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleImageUpload}
                    disabled={!formData.id}
                  />
                </div>
              </div>

              <div className="mt-4">
                <label
                  htmlFor="price"
                  className="block mb-1 text-sm font-medium text-gray-700"
                >
                  Price*
                </label>
                <input
                  id="price"
                  name="price"
                  type="number"
                  required
                  data-testid="menu-item-price-input"
                  value={formData.amount || formData.price}
                  onChange={handleChange}
                  className="px-3 py-2 w-full text-sm font-bold rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                  placeholder="0.00"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="discountAmount"
                  className="block mb-1 text-sm font-medium text-gray-700"
                >
                  Discount Amount
                </label>
                <input
                  id="discountAmount"
                  name="discountAmount"
                  type="number"
                  data-testid="menu-item-discount-input"
                  value={formData.discountAmount}
                  onChange={handleChange}
                  className={`w-full px-3 py-2 text-sm border-b focus:outline-none transition-all duration-200 rounded-none ${discountError
                    ? "border-red-500 focus:border-red-500"
                    : "border-gray-300 focus:border-blue-500"
                    }`}
                  placeholder="0.00"
                />
                {discountError && (
                  <p className="mt-1 text-xs text-red-500">
                    Discount cannot be greater than price
                  </p>
                )}
              </div>
              <div>
                <h3 className="mb-2 text-sm font-medium text-gray-700">
                  Additional Information
                </h3>
                <div className="space-y-3">
                  <div>
                    <label
                      htmlFor="itmNo"
                      className="block mb-1 text-xs text-gray-500"
                    >
                      ID Number
                    </label>
                    <input
                      id="itmNo"
                      name="itmNo"
                      type="text"
                      data-testid="menu-item-id-input"
                      value={formData.itmNo}
                      onChange={handleChange}
                      className="px-3 py-2 w-full text-sm rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter ID"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="rating"
                      className="block mb-1 text-xs text-gray-500"
                    >
                      Rating (0-5)
                    </label>
                    <div className="flex items-center">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          type="button"
                          className="focus:outline-none"
                          onMouseEnter={() => setHoverRating(star)}
                          onMouseLeave={() => setHoverRating(0)}
                          onClick={() => handleRatingChange(star)}
                        >
                          <Star
                            className={`h-6 w-6 ${(hoverRating || rating) >= star
                              ? "fill-yellow-400 text-yellow-400"
                              : "text-gray-300"
                              }`}
                          />
                        </button>
                      ))}
                      <span className="ml-2 text-sm text-gray-600">
                        <input
                          type="number"
                          value={rating}
                          max={5}
                          min={0}
                          step={0.1}
                          onChange={(e) => {
                            setRating(e.target.value);
                            setFormData((prev) => ({
                              ...prev,
                              rating: e.target.value,
                            }));
                          }}
                          style={{
                            WebkitAppearance: "none",
                            MozAppearance: "textfield",
                            outline: "none",
                          }}
                          className={`w-12 rounded-md text-center border border-gray-300 px-3 py-1.5 text-sm focus:outline-none`}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-6 md:col-span-2">
              <div>
                <h3 className="mb-2 text-sm font-medium text-gray-700">
                  Menu Item Details
                </h3>
                <div className="grid grid-cols-1 gap-4 mb-4 md:grid-cols-2">
                  <div>
                    <label
                      htmlFor="name"
                      className="block mb-1 text-xs text-gray-500"
                    >
                      Menu Item Name*
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      required
                      data-testid="menu-item-name-input"
                      value={formData.name}
                      onChange={handleChange}
                      className="px-3 py-2 w-full text-sm rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter menu item name"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="categoryId"
                      className="block mb-1 text-xs text-gray-500"
                    >
                      Category*
                    </label>
                    <select
                      id="categoryId"
                      name="categoryId"
                      required
                      data-testid="menu-item-category-select"
                      value={formData.categoryId}
                      onChange={handleChange}
                      className="px-3 py-2 w-full text-sm rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    >
                      {categories && categories.length > 0 ? (
                        categories.map((category) => (
                          <option
                            key={category.categoryId}
                            value={category.categoryId}
                          >
                            {category.categoryName}
                          </option>
                        ))
                      ) : (
                        <option value="">No categories available</option>
                      )}
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="subCategoryName"
                      className="block mb-1 text-xs text-gray-500"
                    >
                      Sub Category
                    </label>
                    <input
                      id="subCategoryName"
                      name="subCategoryName"
                      type="text"
                      data-testid="menu-item-subcategory-input"
                      value={formData.subCategoryName}
                      onChange={handleChange}
                      className="px-3 py-2 w-full text-sm rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter subcategory"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="description"
                    className="block mb-1 text-xs text-gray-500"
                  >
                    Description
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    data-testid="menu-item-description-input"
                    value={formData.description}
                    onChange={handleChange}
                    rows={4}
                    className="px-3 py-2 w-full text-sm rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter menu item description"
                  />
                </div>

                {/* Types Section */}
                <div className="mt-6">
                  <h3 className="mb-2 text-sm font-medium text-gray-700">
                    Types
                  </h3>
                  <div className="flex flex-wrap gap-1.5">
                    <label
                      data-testid="menu-item-status-label"
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${formData.status
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-500"
                        }`}
                    >
                      <input
                        type="checkbox"
                        name="status"
                        data-testid="menu-item-status-checkbox"
                        checked={formData.status}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">Active</span>
                    </label>

                    <label
                      data-testid="menu-item-veg-label"
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${formData.veg
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-500"
                        }`}
                    >
                      <input
                        type="checkbox"
                        name="veg"
                        data-testid="menu-item-veg-checkbox"
                        checked={formData.veg}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">Vegetarian</span>
                    </label>

                    <label
                      data-testid="menu-item-nonveg-label"
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${formData.nonveg
                        ? "bg-red-100 text-red-800"
                        : "bg-gray-100 text-gray-500"
                        }`}
                    >
                      <input
                        type="checkbox"
                        name="nonveg"
                        data-testid="menu-item-nonveg-checkbox"
                        checked={formData.nonveg}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">Non-Veg</span>
                    </label>

                    <label
                      data-testid="menu-item-chefspecial-label"
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${formData.chefspe
                        ? "bg-purple-100 text-purple-800"
                        : "bg-gray-100 text-gray-500"
                        }`}
                    >
                      <input
                        type="checkbox"
                        name="chefspe"
                        data-testid="menu-item-chefspecial-checkbox"
                        checked={formData.chefspe}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <Award className="mr-0.5 h-3 w-3" />
                      <span className="text-xs">Chef's Special</span>
                    </label>

                    <label
                      data-testid="menu-item-bestseller-label"
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${formData.bestSellar
                        ? "bg-amber-100 text-amber-800"
                        : "bg-gray-100 text-gray-500"
                        }`}
                    >
                      <input
                        type="checkbox"
                        name="bestSellar"
                        data-testid="menu-item-bestseller-checkbox"
                        checked={formData.bestSellar}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <Fire className="mr-0.5 h-3 w-3" />
                      <span className="text-xs">Best Seller</span>
                    </label>

                    <label
                      data-testid="menu-item-spicy-label"
                      className={`flex items-center rounded-full px-2 py-1 cursor-pointer transition-colors ${formData.specify
                        ? "bg-blue-100 text-blue-800"
                        : "bg-gray-100 text-gray-500"
                        }`}
                    >
                      <input
                        type="checkbox"
                        name="specify"
                        data-testid="menu-item-spicy-checkbox"
                        checked={formData.specify}
                        onChange={handleCheckbox}
                        className="sr-only"
                      />
                      <span className="text-xs">spicy</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Variations */}
          <div>
            <h3 className="mb-4 text-base font-medium text-gray-700">
              Variations
            </h3>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
              {/* Add this to the variations mapping to show customer pricing indicator */}
              {variations.map((variation, index) => (
                <div
                  key={index}
                  className="p-4 bg-gray-50 rounded-xl border border-gray-100 transition-all duration-200 cursor-pointer hover:shadow-md hover:border-blue-200"
                  onClick={() => openVariationModal(variation, index)}
                >
                  <div className="flex justify-between items-center mb-1">
                    <div className="text-sm font-medium">
                      {variation.name || "Unnamed Variation"}
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeVariation(index);
                      }}
                      className="p-1 text-gray-400 rounded-full transition-colors hover:text-red-500 hover:bg-gray-200"
                    >
                      <Trash className="w-3.5 h-3.5" />
                    </button>
                  </div>
                  <div className="text-sm text-gray-500">
                    {variation.amount || "0.00"}
                  </div>
                  {variation.priceRules && variation.priceRules.length > 0 && (
                    <div className="mt-1 text-xs text-blue-600">
                      {variation.priceRules.length} custom price
                      {variation.priceRules.length > 1 ? "s" : ""}
                    </div>
                  )}
                </div>
              ))}

              {/* Add Variation Button */}
              <button
                type="button"
                data-testid="add-variation-button"
                onClick={() => openVariationModal()}
                className="flex flex-col justify-center items-center p-4 h-full text-gray-500 rounded-xl border-2 border-gray-300 border-dashed transition-all duration-200 hover:border-blue-400 hover:text-blue-600"
              >
                <Plus className="mb-1 w-5 h-5" />
                <span className="text-sm">Add Variation</span>
              </button>
            </div>
          </div>

          {/* Add-ons */}
          <div className="pt-6 border-t">
            <h3 className="mb-4 text-base font-medium text-gray-700">Add On</h3>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
              {addOns.map((addon, index) => (
                <div
                  key={index}
                  className="p-4 bg-gray-50 rounded-xl border border-gray-100 transition-all duration-200 cursor-pointer hover:shadow-md hover:border-blue-200"
                  onClick={() => openAddOnModal(addon, index)}
                >
                  <div className="flex justify-between items-center mb-1">
                    <div className="text-sm font-medium">
                      {addon.name || "Unnamed Add-on"}
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeAddOn(index);
                      }}
                      className="p-1 text-gray-400 rounded-full transition-colors hover:text-red-500 hover:bg-gray-200"
                    >
                      <Trash className="w-3.5 h-3.5" />
                    </button>
                  </div>
                  <div className="text-sm text-gray-500">
                    {addon.amount || "0.00"}
                  </div>
                </div>
              ))}

              {/* Add Add-on Button */}
              <button
                type="button"
                data-testid="add-addon-button"
                onClick={() => openAddOnModal()}
                className="flex flex-col justify-center items-center p-4 h-full text-gray-500 rounded-xl border-2 border-gray-300 border-dashed transition-all duration-200 hover:border-blue-400 hover:text-blue-600"
              >
                <Plus className="mb-1 w-5 h-5" />
                <span className="text-sm">Add Add-on</span>
              </button>
            </div>
          </div>

          {/* Price Rules */}
          {!DISABLED_FEATURES.includes("priceRule") && menuItem !== null && (
            <div className="pt-6 border-t">
              <h3 className="mb-4 text-base font-medium text-gray-700">
                Custom Price
              </h3>

              {/* Input row for adding new rules - full width */}
              <div className="grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 mb-4 w-full">
                <div>
                  <select
                    data-testid="price-rule-room-select"
                    className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                    value={currentPriceRule.room}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        room: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Room</option>
                    <option value="*">All Rooms</option>
                    {store.rooms.map((room) => (
                      <option key={room.roomName} value={room.roomName}>
                        {room.roomName}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <select
                    data-testid="price-rule-table-select"
                    className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                    value={currentPriceRule.table}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        table: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Table</option>
                    <option value="*">All Tables</option>

                    {Object.values(store.tables)
                      .filter(
                        (table) => currentPriceRule.room == table.roomName
                      )
                      .map((table) => (
                        <option key={table.tableNo} value={table.tableNo}>
                          {table.tableNo}
                        </option>
                      ))}
                  </select>
                </div>
                <div>
                  <select
                    data-testid="price-rule-time-select"
                    className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                    value={currentPriceRule.time}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        time: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Time</option>
                    <option value="*">Whole Day</option>
                    <option value="Custom">Custom Time Range</option>
                  </select>

                  {currentPriceRule.time === "Custom" && (
                    <div className="flex items-center mt-2 space-x-1">
                      <select
                        className="px-2 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                        value={currentPriceRule.timeStart || ""}
                        onChange={(e) => {
                          const startTime = e.target.value;
                          const endTime = currentPriceRule.timeEnd || "";
                          setCurrentPriceRule({
                            ...currentPriceRule,
                            timeStart: startTime,
                            time: "Custom",
                          });
                        }}
                      >
                        <option value="">Start</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={`${i === 0 ? 12 : i}:00 AM`}>
                            {i === 0 ? 12 : i}:00 AM
                          </option>
                        ))}
                        {[...Array(12)].map((_, i) => (
                          <option
                            key={i + 12}
                            value={`${i === 0 ? 12 : i}:00 PM`}
                          >
                            {i === 0 ? 12 : i}:00 PM
                          </option>
                        ))}
                      </select>
                      <span className="text-gray-500">-</span>
                      <select
                        className="px-2 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                        value={currentPriceRule.timeEnd || ""}
                        onChange={(e) => {
                          const startTime = currentPriceRule.timeStart || "";
                          const endTime = e.target.value;
                          setCurrentPriceRule({
                            ...currentPriceRule,
                            timeEnd: endTime,
                            time: "Custom",
                          });
                        }}
                      >
                        <option value="">End</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={`${i === 0 ? 12 : i}:00 AM`}>
                            {i === 0 ? 12 : i}:00 AM
                          </option>
                        ))}
                        {[...Array(12)].map((_, i) => (
                          <option
                            key={i + 12}
                            value={`${i === 0 ? 12 : i}:00 PM`}
                          >
                            {i === 0 ? 12 : i}:00 PM
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <div>
                  <input
                    type="number"
                    data-testid="price-rule-price-input"
                    placeholder="Price"
                    className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                    value={currentPriceRule.price}
                    onChange={(e) =>
                      setCurrentPriceRule({
                        ...currentPriceRule,
                        price: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="flex items-center">
                  <button
                    type="button"
                    data-testid="save-price-rule-button"
                    onClick={savePriceRule}
                    className="p-2 text-white bg-blue-600 rounded-full shadow-sm transition-all duration-200 hover:bg-blue-700 hover:shadow"
                    title="Add rule"
                  >
                    <Plus className="w-4 h-4" />
                  </button>
                </div>
              </div>

              {/* List of existing rules - full width */}
              <div className="space-y-2 w-full">
                {priceRules.map((rule, index) =>
                  rule.room || rule.table || rule.time || rule.price ? (
                    <div
                      key={index}
                      className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-100 transition-all duration-200 hover:border-blue-200 hover:shadow-sm"
                    >
                      <div className="grid grid-cols-4 gap-4 w-full text-sm">
                        <div>
                          <span className="text-gray-500">Room:</span>{" "}
                          {rule.room
                            ? rule.room === "*"
                              ? "All Rooms"
                              : rule.room
                            : "Any"}
                        </div>
                        <div>
                          <span className="text-gray-500">Table:</span>{" "}
                          {rule.table
                            ? rule.table === "*"
                              ? "All Tables"
                              : rule.table
                            : "Any"}
                        </div>
                        <div>
                          <span className="text-gray-500">Time:</span>{" "}
                          {rule.time
                            ? rule.time === "*"
                              ? "Whole Day"
                              : rule.time
                            : "Any"}
                        </div>
                        <div>
                          <span className="text-gray-500">Price:</span>{" "}
                          {rule.price || "0.00"}
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          type="button"
                          onClick={() => removePriceRule(index)}
                          className="p-1 text-red-500 rounded-full transition-colors hover:text-red-700 hover:bg-gray-200"
                          title="Delete rule"
                        >
                          <Trash className="w-3.5 h-3.5" />
                        </button>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="flex justify-end pt-6 border-t">
            <button
              type="submit"
              data-testid="save-menu-item-button"
              className="px-6 py-2.5 bg-blue-600 rounded-full text-sm font-medium text-white hover:bg-blue-700 transition-all duration-200 shadow-sm hover:shadow"
            >
              {menuItem ? "Update Menu Item" : "Save Menu Item"}
            </button>
          </div>
        </form>
      </div>

      {/* Variation Modal */}
      {showVariationModal && (
        <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-black bg-opacity-50" data-testid="variation-modal">
          <div className="bg-white rounded-xl shadow-lg max-w-[70%] w-full p-5">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-800">
                {currentVariationIndex !== null
                  ? "Edit Variation"
                  : "Add Variation"}
              </h3>
              <button
                type="button"
                onClick={() => closeVariationModal()}
                className="p-1 text-gray-500 rounded-full transition-all duration-200 hover:text-gray-700 hover:bg-gray-100"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label
                  htmlFor="variation-name"
                  className="block mb-1 text-sm text-gray-600"
                >
                  Variation Name
                </label>
                <input
                  id="variation-name"
                  type="text"
                  data-testid="variation-name-input"
                  value={currentVariation.name}
                  onChange={(e) =>
                    setCurrentVariation({
                      ...currentVariation,
                      name: e.target.value,
                    })
                  }
                  className="px-3 py-2 w-full rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Small, Medium, Large"
                />
              </div>

              <div>
                <label
                  htmlFor="variation-price"
                  className="block mb-1 text-sm text-gray-600"
                >
                  Price
                </label>
                <input
                  id="variation-price"
                  type="number"
                  data-testid="variation-price-input"
                  value={currentVariation.amount}
                  onChange={(e) =>
                    setCurrentVariation({
                      ...currentVariation,
                      amount: e.target.value,
                    })
                  }
                  className="px-3 py-2 w-full rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                  placeholder="0.00"
                />
              </div>
              {/* Add this to the Variation Modal before the buttons */}
              {currentVariationIndex !== null && menuItem && (
                <div className="mt-4">
                  <label className="block mb-1 text-sm text-gray-600">
                    Custom Pricing (Optional)
                  </label>
                  <div className="pt-4 rounded-lg">
                    <div className="grid grid-cols-[1fr_1fr_1fr_1fr_auto] gap-4 mb-4 w-full">
                      <div>
                        <select
                          className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                          value={currentVariationPriceRule.room}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              room: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Room</option>
                          <option value="*">All Rooms</option>
                          {store.rooms.map((room) => (
                            <option key={room.roomName} value={room.roomName}>
                              {room.roomName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <select
                          className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                          value={currentVariationPriceRule.table}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              table: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Table</option>
                          <option value="*">All Tables</option>
                          {Object.values(store.tables)
                            .filter(
                              (table) =>
                                currentVariationPriceRule.room == table.roomName
                            )
                            .map((table) => (
                              <option key={table.tableNo} value={table.tableNo}>
                                {table.tableNo}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div>
                        <select
                          className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                          value={currentVariationPriceRule.time}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              time: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Time</option>
                          <option value="*">Whole Day</option>
                          <option value="Custom">Custom Time Range</option>
                        </select>

                        {currentVariationPriceRule.time === "Custom" && (
                          <div className="flex items-center mt-2 space-x-1">
                            <select
                              className="px-2 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                              value={currentVariationPriceRule.timeStart || ""}
                              onChange={(e) => {
                                const startTime = e.target.value;
                                const endTime =
                                  currentVariationPriceRule.timeEnd || "";
                                setCurrentVariationPriceRule({
                                  ...currentVariationPriceRule,
                                  timeStart: startTime,
                                  time: "Custom",
                                });
                              }}
                            >
                              <option value="">Start</option>
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i}
                                  value={`${i === 0 ? 12 : i}:00 AM`}
                                >
                                  {i === 0 ? 12 : i}:00 AM
                                </option>
                              ))}
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i + 12}
                                  value={`${i === 0 ? 12 : i}:00 PM`}
                                >
                                  {i === 0 ? 12 : i}:00 PM
                                </option>
                              ))}
                            </select>
                            <span className="text-gray-500">-</span>
                            <select
                              className="px-2 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                              value={currentVariationPriceRule.timeEnd || ""}
                              onChange={(e) => {
                                const startTime =
                                  currentVariationPriceRule.timeStart || "";
                                const endTime = e.target.value;
                                setCurrentVariationPriceRule({
                                  ...currentVariationPriceRule,
                                  timeEnd: endTime,
                                  time: "Custom",
                                });
                              }}
                            >
                              <option value="">End</option>
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i}
                                  value={`${i === 0 ? 12 : i}:00 AM`}
                                >
                                  {i === 0 ? 12 : i}:00 AM
                                </option>
                              ))}
                              {[...Array(12)].map((_, i) => (
                                <option
                                  key={i + 12}
                                  value={`${i === 0 ? 12 : i}:00 PM`}
                                >
                                  {i === 0 ? 12 : i}:00 PM
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                      <div>
                        <input
                          type="number"
                          placeholder="Price"
                          className="px-3 py-2 w-full text-sm rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                          value={currentVariationPriceRule.price}
                          onChange={(e) =>
                            setCurrentVariationPriceRule({
                              ...currentVariationPriceRule,
                              price: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="flex items-center">
                        <button
                          type="button"
                          onClick={addVariationPriceRule}
                          className="p-2 text-white bg-blue-600 rounded-full shadow-sm transition-all duration-200 hover:bg-blue-700 hover:shadow"
                          title="Add rule"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                    </div>

                    {/* List of custom pricing rules */}
                    <div className="space-y-2 w-full">
                      {currentVariation.priceRules &&
                        currentVariation.priceRules.map((rule, index) => (
                          <div
                            key={index}
                            className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-100 transition-all duration-200 hover:border-blue-200 hover:shadow-sm"
                          >
                            <div className="grid grid-cols-4 gap-4 w-full text-sm">
                              <div>
                                <span className="text-gray-500">Room:</span>{" "}
                                {rule.room === "*"
                                  ? "All Rooms"
                                  : rule.room || "Any"}
                              </div>
                              <div>
                                <span className="text-gray-500">Table:</span>{" "}
                                {rule.table === "*"
                                  ? "All Tables"
                                  : rule.table || "Any"}
                              </div>
                              <div>
                                <span className="text-gray-500">Time:</span>{" "}
                                {rule.time === "*"
                                  ? "Whole Day"
                                  : rule.time || "Any"}
                              </div>
                              <div>
                                <span className="text-gray-500">Price:</span>{" "}
                                {rule.price || "0.00"}
                              </div>
                            </div>
                            <div className="flex items-center space-x-2">
                              <button
                                type="button"
                                onClick={() => removeVariationPriceRule(index)}
                                className="p-1 text-red-500 rounded-full transition-colors hover:text-red-700 hover:bg-gray-200"
                                title="Delete rule"
                              >
                                <Trash className="w-3.5 h-3.5" />
                              </button>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}

              <div className="flex justify-end mt-6 space-x-3">
                <button
                  type="button"
                  onClick={closeVariationModal}
                  className="px-4 py-2 text-sm text-gray-600 rounded-lg border border-gray-300 transition-all duration-200 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  data-testid="save-variation-button"
                  onClick={saveVariation}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg shadow-sm transition-all duration-200 hover:bg-blue-700 hover:shadow"
                >
                  {currentVariationIndex !== null ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add-on Modal */}
      {showAddOnModal && (
        <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-black bg-opacity-50" data-testid="addon-modal">
          <div className="p-5 w-full max-w-md bg-white rounded-xl shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-800">
                {currentAddOnIndex !== null ? "Edit Add-on" : "Add Add-on"}
              </h3>
              <button
                type="button"
                onClick={() => setShowAddOnModal(false)}
                className="p-1 text-gray-500 rounded-full transition-all duration-200 hover:text-gray-700 hover:bg-gray-100"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label
                  htmlFor="addon-name"
                  className="block mb-1 text-sm text-gray-600"
                >
                  Add-on Name
                </label>
                <input
                  id="addon-name"
                  type="text"
                  data-testid="addon-name-input"
                  value={currentAddOn.name}
                  onChange={(e) =>
                    setCurrentAddOn({ ...currentAddOn, name: e.target.value })
                  }
                  className="px-3 py-2 w-full rounded-lg border border-gray-300 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Extra Cheese, Mushrooms"
                />
              </div>

              <div>
                <label
                  htmlFor="addon-price"
                  className="block mb-1 text-sm text-gray-600"
                >
                  Price
                </label>
                <input
                  id="addon-price"
                  type="text"
                  data-testid="addon-price-input"
                  value={currentAddOn.amount}
                  onChange={(e) =>
                    setCurrentAddOn({ ...currentAddOn, amount: e.target.value })
                  }
                  className="px-3 py-2 w-full rounded-none border-b border-gray-300 transition-all duration-200 focus:border-blue-500 focus:outline-none"
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="flex justify-end mt-6 space-x-3">
              <button
                type="button"
                onClick={() => setShowAddOnModal(false)}
                className="px-4 py-2 text-sm text-gray-600 rounded-lg border border-gray-300 transition-all duration-200 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="button"
                data-testid="save-addon-button"
                onClick={saveAddOn}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg shadow-sm transition-all duration-200 hover:bg-blue-700 hover:shadow"
              >
                {currentAddOnIndex !== null ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
